import React, { FC, PropsWithChildren } from 'react';
import ChevronRight from '@gravity-ui/icons/ChevronRight';
import { Link } from 'react-router-dom';

import styles from './MenuMobile.module.scss';

export interface IMenuMobileItem {
    value: string;
    content: React.ReactNode;
    items?: IMenuMobileItem[];
}

export const MenuMobile: FC<
    PropsWithChildren<{ menuItems: IMenuMobileItem[]; externalAsideLinks: IMenuMobileItem[]; currentPath?: string }>
> = ({ children, currentPath, externalAsideLinks, menuItems }) => {
    const currentPathIndex = menuItems.findIndex((menuItem) => menuItem.value === currentPath);
    const menuItemsAboveCurrentPage = menuItems.slice(0, currentPathIndex);
    const menuItemsBelowCurrentPage = menuItems.slice(currentPathIndex + 1);

    return (
        <>
            {menuItemsAboveCurrentPage.map((menuItem) => (
                <Link key={menuItem.value} className={styles.navLinkMobile} to={menuItem.value}>
                    <ChevronRight />
                    {menuItem?.content}
                </Link>
            ))}
            {children}
            {menuItemsBelowCurrentPage.map((menuItem) => (
                <Link key={menuItem.value} className={styles.navLinkMobile} to={menuItem.value}>
                    <ChevronRight />
                    {menuItem.content}
                </Link>
            ))}
            {externalAsideLinks.map((linkItem) => (
                <a key={linkItem.value} className={styles.navLinkMobile} href={linkItem.value}>
                    <ChevronRight />
                    {linkItem.content}
                </a>
            ))}
        </>
    );
};
